/* THE ILLUMINATEE - lock the product-page image gallery (v3.9)

   The shopper should change the product photo ONLY with the colour buttons.
   The injected CSS below locks horizontal scrolling on every viewport. On
   DESKTOP the theme also drags the gallery from JS: assets/slideshow.js binds
   a 'mousedown' listener on the scroller and then moves it with pointermove +
   Scroller.by(), which CSS cannot stop. So:

     1. swallow 'mousedown' inside the gallery in the CAPTURE phase, before it
        reaches the theme's listener (drag never starts);
     2. kill native horizontal scrolling (trackpad / shift-wheel / scrollbar /
        touch) with overflow-x:hidden - programmatic scrollLeft still works, so
        selecting a colour keeps scrolling the gallery to that colour's slide.

   The zoom dialog is deliberately left fully interactive.
*/
(function () {
  var CSS = [
    /* main gallery: no user scrolling, programmatic scroll still works */
    'body media-gallery slideshow-slides{',
    'overflow-x:hidden !important;',
    'scroll-snap-type:none !important;',
    'touch-action:pan-y !important;',
    '}',
    /* keep the fullscreen / zoom view browsable */
    'body zoom-dialog slideshow-slides{',
    'overflow-x:auto !important;',
    'scroll-snap-type:x mandatory !important;',
    'touch-action:auto !important;',
    '}'
  ].join('');

  function injectStyle() {
    if (document.getElementById('illmn-gallery-nodrag-style')) return;
    var s = document.createElement('style');
    s.id = 'illmn-gallery-nodrag-style';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  injectStyle();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectStyle);
  }

  /* Capture-phase blocker: runs before assets/slideshow.js #handleMouseDown,
     which is bound directly on the scroller (bubble phase). */
  document.addEventListener(
    'mousedown',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var scroller = target.closest('slideshow-slides, slideshow-container');
      if (!scroller) return;
      if (!scroller.closest('media-gallery')) return; /* only the PDP gallery */
      if (scroller.closest('zoom-dialog')) return; /* leave zoom alone */

      /* Stop the theme's drag handler from ever seeing this event. Clicks are
         unaffected (click still fires), so opening the zoom view still works.
         preventDefault mirrors what the theme did: no native image drag or
         text selection. */
      event.stopImmediatePropagation();
      event.preventDefault();
    },
    true
  );
})();
